<template>
  <div class="customer-list">
    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList">
      <van-collapse v-model="activeName" accordion>
        <van-collapse-item
          :name="index"
          :is-link="false"
          v-for="(item, index) in list"
          :key="index"
        >
          <template #title>
            <div class="title">
              <div class="title-left">
                <span class="name">{{ item.openId }}</span>
                <div class="number">领取时间: {{ item.createdTime}}</div>
              </div>
              <div class="title-right">
                <div class="name">￥-{{ item.amount }}</div>
                <div class="number">{{ item.type | type}}</div>
              </div>
            </div>
          </template>
          <div class="content">
            <div class="list">
              <span class="list-left">分享职员</span>
              <span class="list-right">{{ item.h5UserName}}</span>
            </div>
            <div class="list">
              <span class="list-left">分享门店</span>
              <span class="list-right">{{ item.storeName }}</span>
            </div>
            <div class="list">
              <span class="list-left">领取状态</span>
              <span class="list-right">{{ item.status | claimStatus }}</span>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </refresh-list>
  </div>
</template>

<script>
import refreshList from "@/components/refresh-list/refresh-list";
export default {
  components: {
    refreshList,
  },
  data() {
    return {
      activeName: "1",
      list: [],
      pageNum: 1,
      pageSize: 20,
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      let data = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData:  {
          ...this.$route.query
        }
      };
      this.$api.activityMgmt
        .getActivityRedPackUseList(data)
        .then((res) => {
          if (res.code == 200) {
            this.list.push(...res.data.list);
            this.pageNum = res.data.pageNum + 1;
            this.$refs["refreshList"].complete(res.data);
          } else {
            this.$refs["refreshList"].onFinish();
          }
        })
        .catch((err) => {
          this.$refs["refreshList"].onFinish();
        });
    },
  },
  filters: {
    signupStatus(status) {
      let map = {
        1: "已报名",
        2: "已核销",
        3: "已退款",
        4: "报名失败",
        5: "退款",
        6: '抽奖现金红包'
      };
      return map[status];
    },
    type(type) {
      let map = {
        1: "现金红包",
        2: "裂变佣金",
        3: "活动结束退款",
        6: '抽奖现金红包',
        8: "活动结束退款"
      };
      return map[type];
    },
    claimStatus(status) {
       let map = {
        0: '未处理',
        '-1': '失败',
        1: "成功 ",
        2: '处理中'
      };
      return map[status]
    }
  },
};
</script>
<style lang="stylus" scoped>
.customer-list {
	.van-pull-refresh {
		min-height: 100vh;
		.title {
			display: flex;
			justify-content: space-between;
			.title-left {
				color: #333333;
				font-size: 16px;
        width:74%;
        // background: red;
				.number {
					color: #999999;
					font-size: 13px
				}
        .name {
          text-align: justify;
          text-justify: newspaper;
          word-break: break-all;
        }
			}
      .title-right {
        width: 25%;
        // background: pink;
      }
			.right-img {
				width 32px
				height 32px
			}
		}
		.content {
			.list {
				display: flex;
				justify-content: space-between;
				align-items: center;
				width: 100%;
				height: 44px;
				color: #999999;
				font-size: 14px;
				.list-right {
					display: flex;
					justify-content: flex-end;
					color: #333333;
					width: 270px;
				}
			}
		}
  }
}
</style>
